export const FACET_ORDER = ['style', 'color', 'price', 'photo', 'foil', 'orientation', 'size', 'format'] as const;
